import React from 'react';
import Api from '../../../js/Api';
import Utilities from '../../../js/Utilities';
import StatsTable from '../../Common/StatsTable/StatsTable';
import Totals from '../../Common/Totals/Totals';
import ReportsHeader from '../../Common/ReportsHeader/ReportsHeader';
import './Reports.css';
import '../../Common/StatsTable/StatsTable.css';
import Loader from '../../Common/Loader/Loader';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleRight, faTimes, faChevronDown, faSearch, faFileCsv } from '@fortawesome/free-solid-svg-icons';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Line } from 'rc-progress';
import { Bar } from 'react-chartjs-2';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

const Client = new Api();
const moment = require('moment-timezone');
class Reports extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            loading:true,
            viewMode:'day',
            storeMode:'all',
            browser : Utilities.getCurrentBrowser(),
            currentMonth:moment.tz(moment(), 'Asia/Kolkata').format('YYYY-MM'),
            goalKey:`all-${moment.tz(moment(), 'Asia/Kolkata').format('MM-YYYY')}`,
            startDate : moment.tz(moment(), 'Asia/Kolkata').format('YYYY-MM-DD'),
            endDate : moment.tz(moment(), 'Asia/Kolkata').format('YYYY-MM-DD'),
            cash : 0.0,
            cashCount : 0,
            sourceTotals:{},
            revenueTotals : [],
            orderTypeTotals: {},
            toppingsCounter: {},
            branchTotals:[],
            customerName : '',
            money : 0.0,
            data : null,
            stats : null,
            orderCount : 0,
            totalOrderCount: 0,
            snackCount : 0,
            drinksCount : 0,
            totalDrinksValue:0.0,
            totalFoodValue:0.0,
            orders:null,
            addOnItems : [],
            orderItems : [],
            unknownOrderCount : 0,
            phoneNum:props.match.params.phonenum,
            daysYet:1,
            goalData:null,
            totalAmount:0.0,
            totalNetAmount:0.0,
            averageDailyRevenue:0.0,
            expectedTotal:0.0,
            totalDiscounts:0.0,
            branches: [],
            selectedBranches: [],
            branchSearch: '',
            debounceTimer: null,
            branchSortBy: 'value',
            branchSortOrder: 'desc',
            groupByCity: false,
            branchCityMap: {},
            cities: [],
            selectedCities: [],
            isPastMonthEnd: false,
            loadError: null
        }
        this.timer = null;
    }

    loadOrders = async ()=>{
        const {startDate, endDate, viewMode, storeMode, selectedBranches, currentMonth,goalKey } = this.state;
        let fbChat = document.querySelector('.fb_dialog');
        if(fbChat){ fbChat.remove();}
        let startDateString = moment.tz(startDate,'Asia/Kolkata').format('YYYY-MM-DD');
        let endDateString = moment.tz(endDate,'Asia/Kolkata').format('YYYY-MM-DD');
        let goalData = null;

        if(viewMode === "month"){
            startDateString = moment(currentMonth).startOf('month').format('YYYY-MM-DD');
            endDateString   = moment(currentMonth).endOf('month').format('YYYY-MM-DD');
            let numDaysInMonth = moment(currentMonth).daysInMonth();

            let goalKey = `${storeMode}-${moment(currentMonth).format('MM-YYYY')}`;
            try {
                goalData = await Client.getGoalData(goalKey);
            } catch (error) {
                
            }
        }
        
        let daysYet = moment(startDate).endOf('month').diff(moment(endDate).startOf('month'), 'days');
        if(moment(startDate).endOf('month') > moment().endOf('day')){
            daysYet = moment().endOf('day').diff(moment(endDate).startOf('month'), 'days');
        }
        daysYet = Math.abs(daysYet);
        this.setState({
            daysYet,
            goalData,
            loading:true,
            loadError: null
        },()=>{
            // Don't make API call if no branches are selected
            if (!selectedBranches || selectedBranches.length === 0) {
                // Check if current date is past the last date of the selected month (only for month view)
                const isPastMonthEnd = viewMode === "month" && moment.tz(moment(), 'Asia/Kolkata').isAfter(moment(currentMonth).endOf('month'), 'day');
                this.setState({
                    loading: false,
                    totalOrderCount: 0,
                    totalAmount: 0,
                    totalNetAmount: 0,
                    totalDiscounts: 0,
                    sourceTotals: {},
                    periodTotals: {},
                    revenueTotals: [],
                    orderTypeTotals: {},
                    branchTotals: [],
                    orderItems: [],
                    expectedTotal: 0,
                    averageDailyRevenue: 0,
                    // Clear all filtered data variables
                    data: [],
                    customerName: '',
                    overallDrinksCounter: {},
                    overallSnacksCounter: {},
                    overallOtherCounter: {},
                    overallComboCounter: {},
                    posPickupDrinksCounter: {},
                    posPickupSnacksCounter: {},
                    posDineInDrinksCounter: {},
                    posDineInSnacksCounter: {},
                    posDineInComboCounter: {},
                    zomatoDeliveryDrinksCounter: {},
                    zomatoDeliverySnacksCounter: {},
                    zomatoDeliveryComboCounter: {},
                    swiggyDeliveryDrinksCounter: {},
                    swiggyDeliverySnacksCounter: {},
                    swiggyDeliveryComboCounter: {},
                    dotpeDeliveryDrinksCounter: {},
                    dotpeDeliverySnacksCounter: {},
                    dotpeDeliveryComboCounter: {},
                    orderCount: 0,
                    snackCount: 0,
                    drinksCount: 0,
                    totalDrinksValue: 0,
                    totalFoodValue: 0,
                    money: 0,
                    debounceTimer: null,
                    isPastMonthEnd: isPastMonthEnd
                });
                return;
            }
            
            Client.getGotTeaOrderData(moment(startDateString).add(6,'hours').valueOf(), moment(endDateString).add(1,'days').add(6,'hours').valueOf(),selectedBranches).then((orderData)=>{
                let expectedTotal = 0.0;
                let averageDailyRevenue = 0.0;
                let branchTotals = [];
                let toppingsTotals = {};
                if(viewMode === "month"){
                    console.log("totalNetAmountForLastDay =>",orderData.totalNetAmountForLastDay);
                    console.log("totalNetAmount =>",orderData.totalNetAmount);
                    let numDaysInMonth = moment(currentMonth).daysInMonth();
                    let netRevSoFar = orderData.totalNetAmount - orderData.totalNetAmountForLastDay;
                    averageDailyRevenue = netRevSoFar / daysYet;
                    expectedTotal = (averageDailyRevenue * numDaysInMonth);
                }
               Object.keys(orderData.addOnsTotals).map((key)=>{
                    if(orderData.addOnsTotals[key].categoryName.toLowerCase().trim() === "toppings"){
                        toppingsTotals[orderData.addOnsTotals[key].name] = {
                            count : orderData.addOnsTotals[key].count,
                            value : orderData.addOnsTotals[key].amount
                        }
                    }
                });
                const numDaysInMonth = moment(currentMonth).daysInMonth();
                branchTotals = Object.keys(orderData.branchTotals).map((key)=>{
                    const branchTotal = orderData.branchTotals[key];
                    let branchDailyAverage = 0.0;
                    let estimatedRevenue = 0.0;
                    // Calculate branch-wise daily average and estimated revenue for month view
                    // Calculate each branch independently using actual branch-specific last day revenue
                    if(viewMode === "month" && daysYet > 0 && orderData.totalNetAmount > 0){
                        // Get branch's actual last day revenue from API response
                        const branchLastDayRevenue = orderData.totalNetAmountForLastDayByBranch && orderData.totalNetAmountForLastDayByBranch[key] 
                            ? parseFloat(orderData.totalNetAmountForLastDayByBranch[key]) 
                            : 0.0;
                        // Calculate branch's net revenue so far (excluding last day)
                        const branchNetRevSoFar = parseFloat(branchTotal) - branchLastDayRevenue;
                        // Calculate branch's daily average independently
                        branchDailyAverage = branchNetRevSoFar / daysYet;
                        // Calculate branch's estimated monthly revenue
                        estimatedRevenue = branchDailyAverage * numDaysInMonth;
                    }
                    return {
                        branch: key,
                        value: branchTotal,
                        dailyAverage: branchDailyAverage,
                        estimatedRevenue: estimatedRevenue
                    };
                });
                branchTotals.sort((a, b) => parseFloat(b.value) - parseFloat(a.value));
                // Check if current date is past the last date of the selected month (only for month view)
                const isPastMonthEnd = viewMode === "month" && moment.tz(moment(), 'Asia/Kolkata').isAfter(moment(currentMonth).endOf('month'), 'day');
                this.setState({
                    totalOrderCount:orderData.orderCount,
                    toppingsCounter:toppingsTotals,
                    totalAmount : orderData.totalAmount,
                    totalNetAmount : orderData.totalNetAmount,
                    totalDiscounts : orderData.totalDiscounts,
                    sourceTotals: orderData.sourceTotals,
                    periodTotals:orderData.periodTotals,
                    revenueTotals : Object.keys(orderData.sourceTotals).map((key)=>({Source : key,...orderData.sourceTotals[key]})),
                    orderTypeTotals : orderData.orderTypeTotals,
                    branchTotals:branchTotals,
                    orderItems:orderData.items,
                    expectedTotal:expectedTotal,
                    averageDailyRevenue:averageDailyRevenue,
                    loading:false,
                    debounceTimer: null,
                    isPastMonthEnd: isPastMonthEnd
                },()=>{
                    this.filterOrders();
                });
            }).catch((err)=>{
                console.log('GET GOT TEA DATA ERROR =>', err);
                // Keep the report renderable when the API is temporarily
                // unavailable (for example, during a deployment).
                this.setState({ 
                    loading: false,
                    debounceTimer: null,
                    loadError: 'Unable to load report data. Please try again.',
                    totalOrderCount: 0,
                    totalAmount: 0,
                    totalNetAmount: 0,
                    totalDiscounts: 0,
                    sourceTotals: {},
                    periodTotals: {},
                    revenueTotals: [],
                    orderTypeTotals: {},
                    branchTotals: [],
                    orderItems: [],
                });
            });
        })
    }

    filterOrders = () =>{
        const { orderItems} = this.state;
        let overallDrinksCounter = {};
        let overallSnacksCounter = {};
        let overallComboCounter = {};
        let overallOtherCounter = {};

        let posPickupDrinksCounter = {};
        let posPickupSnacksCounter = {};
        let posDineInDrinksCounter = {};
        let posDineInSnacksCounter = {};
        let posDineInComboCounter = {};
        let posPickupComboCounter =  {};

        let zomatoDeliveryDrinksCounter = {};
        let zomatoDeliverySnacksCounter = {};
        let zomatoDeliveryComboCounter = {};

        let swiggyDeliveryDrinksCounter = {};
        let swiggyDeliverySnacksCounter = {};
        let swiggyDeliveryComboCounter = {};

        let dotpeDeliveryDrinksCounter = {};
        let dotpeDeliverySnacksCounter = {};
        let dotpeDeliveryComboCounter = {};

        /*
        "orderTypeTotals": {
            "TAKEAWAY": {
                "count": 4327,
                "total": 1792308,
                "aov": 414.21
            },
            "DINEIN": {
                "count": 7663,
                "total": 4503359,
                "aov": 587.68
            },
            "DELIVERY": {
                "count": 6288,
                "total": 3573573,
                "aov": 568.32
            }
        },
        */

        let arr = [];
        let money = 0.0;
        let drinksCount = 0;
        let snackCount = 0;
        let totalDrinksValue = 0.0;
        let totalFoodValue = 0.0;
        for(const item of orderItems){
            let orderType = item.Service.toLowerCase();
            let source = item.Source.toLowerCase();
            if(source.includes("zomato")){
                source = "zomato";
            } else if(source.includes("swiggy")){
                source = "swiggy";
            } else if(source.includes("takeaway")){
                source = "takeaway";
            } 
            let isDelivery = orderType === 'delivery';
            let isDineIn = orderType === 'dinein';
            let isTakeaway = orderType === 'takeaway';
            money += parseFloat(item["Revenue"]);
            let itemName = item["Item Name"].trim();
            if(itemName.trim() === "Peachy  Oolong"){
                itemName = "Peachy Oolong";
            }
            if(itemName.toLowerCase().includes("croffle")){
                if(itemName.trim() === "Bubble Tea + Croffle Combo" || itemName.trim() === "1 Bubble Tea + Original Croffle"){
                    itemName = "1 Bubble Tea + 1 Croffle";
                }
                itemName = itemName.replace("(-10%)","").replace("(-10%)","").replace("Croffle - Original","Original Croffle").trim();
                if(itemName.trim() === "Corn and Cheese Croffle"){
                    itemName = "Corn Cheese Croffle";
                }
                if(itemName.trim() === "Dill And Cheese Croffle"){
                    itemName = "Dill & Cheese Croffle";
                }
                if(itemName.trim() === "Dill &amp; Cheese Croffle"){
                    itemName = "Dill & Cheese Croffle";
                }
            } else if(itemName.toLowerCase().includes("sandwich")){
                if(itemName.trim() === "Sandwich Veg"){
                    itemName = "Veg Sandwich";
                }
                if(itemName.trim() === "Non-Veg Sandwich" || itemName.trim() === "Sandwich Non Veg" || itemName.trim() === "Sandwich Chicken"){
                    itemName = "Non - Veg Sandwich";
                }
            } else {
                itemName = itemName.replace("Bubble Tea", "").replace(" (10% Off)","").replace("(-10%)","").replace("[No Bubbles]","").replace("No Bubbles","").replace("[New]","").trim();
            }
            if(itemName.toLowerCase().trim() === "banana milk"){
                itemName = "Korean Banana Milk";
            }
            if(Utilities.isCombo(item.Category)){
                if(Utilities.isNullOrEmpty(overallComboCounter[itemName])){
                    overallComboCounter[itemName] = { count : 0, dineIn : 0, takeaway : 0, delivery : 0, value:0};
                }
                overallComboCounter[itemName].value = overallComboCounter[itemName].value + parseFloat(item["Subtotal"]);
                overallComboCounter[itemName].count = overallComboCounter[itemName].count + parseInt(item["Item Count"]);
                if(isDineIn){
                   posDineInComboCounter[itemName] = (posDineInComboCounter[itemName] || 0) + parseInt(item["Item Count"]);
                   overallComboCounter[itemName].dineIn = overallComboCounter[itemName].dineIn + parseInt(item["Item Count"]);
                } else if(isDelivery){
                    if(source === "zomato"){
                        zomatoDeliveryComboCounter[item["Item Name"]] = (zomatoDeliveryComboCounter[item["Item Name"]] || 0) + parseInt(item["Item Count"]);
                        } else if(source === "swiggy"){
                        swiggyDeliveryComboCounter[item["Item Name"]] = (swiggyDeliveryComboCounter[item["Item Name"]] || 0) + parseInt(item["Item Count"]);
                       }
                    else if(source === "dotpe"){
                        dotpeDeliveryComboCounter[item["Item Name"]] = (dotpeDeliveryComboCounter[item["Item Name"]] || 0) + parseInt(item["Item Count"]);
                     }
                    overallComboCounter[itemName].delivery = overallComboCounter[itemName].delivery + parseInt(item["Item Count"]);
                } else {
                    if(source === "pos"){
                        posPickupComboCounter[item["Item Name"]] = (posPickupComboCounter[item["Item Name"]] || 0) + parseInt(item["Item Count"]);
                        } else if(source === "dotpe"){
                        posPickupComboCounter[item["Item Name"]] = (posPickupComboCounter[item["Item Name"]] || 0) + parseInt(item["Item Count"]);
                       }
                    overallComboCounter[itemName].takeaway = overallComboCounter[itemName].takeaway + parseInt(item["Item Count"]);
                }

            } else if(Utilities.isSnack(itemName)){
                if(itemName.toLowerCase().includes("financiers set")){
                    continue;
                }
                snackCount += parseInt(item["Item Count"]);
                totalFoodValue += parseFloat(item["Subtotal"]);
                if(Utilities.isNullOrEmpty(overallSnacksCounter[itemName])){
                    overallSnacksCounter[itemName] = { count : 0, dineIn : 0, takeaway : 0, delivery : 0, value:0.0};
                }
                overallSnacksCounter[itemName].value = overallSnacksCounter[itemName].value + parseFloat(item["Subtotal"]);
                overallSnacksCounter[itemName].count = overallSnacksCounter[itemName].count + parseInt(item["Item Count"]);
                if(isDineIn){
                    posDineInSnacksCounter[itemName] = (posDineInSnacksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    overallSnacksCounter[itemName].dineIn = overallSnacksCounter[itemName].dineIn + parseInt(item["Item Count"]);
                } else if(isDelivery){
                    if(source === "zomato"){
                        zomatoDeliverySnacksCounter[item["Item Name"]] = (zomatoDeliverySnacksCounter[item["Item Name"]] || 0) + parseInt(item["Item Count"]);
                    } else if(source === "swiggy"){
                        swiggyDeliverySnacksCounter[item["Item Name"]] = (swiggyDeliverySnacksCounter[item["Item Name"]] || 0) + parseInt(item["Item Count"]);
                    }
                    else if(source === "dotpe"){
                        dotpeDeliverySnacksCounter[item["Item Name"]] = (dotpeDeliverySnacksCounter[item["Item Name"]] || 0) + parseInt(item["Item Count"]);
                    }
                    overallSnacksCounter[itemName].delivery = overallSnacksCounter[itemName].delivery + parseInt(item["Item Count"]);
                } else {
                    if(source === "pos"  || source === "takeaway"){
                        posPickupSnacksCounter[item["Item Name"]] = (posPickupSnacksCounter[item["Item Name"]] || 0) + parseInt(item["Item Count"]);
                    } else if(source === "dotpe"){
                        posPickupSnacksCounter[item["Item Name"]] = (posPickupSnacksCounter[item["Item Name"]] || 0) + parseInt(item["Item Count"]);
                    }
                    overallSnacksCounter[itemName].takeaway = overallSnacksCounter[itemName].takeaway + parseInt(item["Item Count"]);
                }
            } 
            
            else if(item["Category"].toLowerCase().trim() === "coffee"){
                drinksCount += parseInt(item["Item Count"]);
                totalDrinksValue += parseFloat(item["Subtotal"]);
                if(Utilities.isNullOrEmpty(overallDrinksCounter[itemName])){
                    overallDrinksCounter[itemName] = { count : 0, dineIn : 0, takeaway : 0, delivery : 0, largeCount:0, regularCount:0, value:0.0};
                }
                overallDrinksCounter[itemName].count = overallDrinksCounter[itemName].count + parseInt(item["Item Count"]);
                overallDrinksCounter[itemName].value = overallDrinksCounter[itemName].value + parseFloat(item["Subtotal"]);
                overallDrinksCounter[itemName].largeCount += parseInt(item["Large Count"]);
                overallDrinksCounter[itemName].regularCount += parseInt(item["Regular Count"]);
                if(overallDrinksCounter[itemName].toppings){
                    for(let topping in item["Toppings"]){
                        if(overallDrinksCounter[itemName].toppings[topping]){
                            overallDrinksCounter[itemName].toppings[topping] += item["Toppings"][topping];
                        } else {
                            overallDrinksCounter[itemName].toppings[topping] = item["Toppings"][topping];
                        }
                    }
                } else {
                    overallDrinksCounter[itemName].toppings = {};
                    for(let topping in item["Toppings"]){
                        if(overallDrinksCounter[itemName].toppings[topping]){
                            overallDrinksCounter[itemName].toppings[topping] += item["Toppings"][topping];
                        } else {
                            overallDrinksCounter[itemName].toppings[topping] = item["Toppings"][topping];
                        }
                    }
                }
                if(overallDrinksCounter[itemName].milkChoice){
                    for(let milk in item["Base"]){
                        if(overallDrinksCounter[itemName].milkChoice[milk]){
                            overallDrinksCounter[itemName].milkChoice[milk] += item["Base"][milk];
                        } else {
                            overallDrinksCounter[itemName].milkChoice[milk] = item["Base"][milk];
                        }
                    }
                } else {
                    overallDrinksCounter[itemName].milkChoice = {};
                    for(let milk in item["Base"]){
                        if(overallDrinksCounter[itemName].milkChoice[milk]){
                            overallDrinksCounter[itemName].milkChoice[milk] += item["Base"][milk];
                        } else {
                            overallDrinksCounter[itemName].milkChoice[milk] = item["Base"][milk];
                        }
                    }
                }
                if(isDineIn){
                    posDineInDrinksCounter[itemName] = (posDineInDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    overallDrinksCounter[itemName].dineIn = overallDrinksCounter[itemName].dineIn + parseInt(item["Item Count"]);
                } else if(isDelivery){
                    if(source === "zomato"){
                        zomatoDeliveryDrinksCounter[itemName] = (zomatoDeliveryDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    } else if(source === "swiggy"){
                        swiggyDeliveryDrinksCounter[itemName] = (swiggyDeliveryDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }
                    else if(source === "dotpe"){
                        dotpeDeliveryDrinksCounter[itemName] = (dotpeDeliveryDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }
                    overallDrinksCounter[itemName].delivery = overallDrinksCounter[itemName].delivery + parseInt(item["Item Count"]);
                } else {
                    if(source === "pos"  || source === "takeaway"){
                        posPickupDrinksCounter[itemName] = (posPickupDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }else if(source === "dotpe"){
                        posPickupDrinksCounter[itemName] = (posPickupDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }
                    overallDrinksCounter[itemName].takeaway = overallDrinksCounter[itemName].takeaway + parseInt(item["Item Count"]);
                }

            } 
            else if(item["Category"].toLowerCase().trim() === "hot drinks" || item["Category"].toLowerCase().trim() === "classic"){
                drinksCount += parseInt(item["Item Count"]);
                totalDrinksValue += parseFloat(item["Subtotal"]);
                if(Utilities.isNullOrEmpty(overallDrinksCounter[itemName])){
                    overallDrinksCounter[itemName] = { count : 0, dineIn : 0, takeaway : 0, delivery : 0, largeCount:0, regularCount:0, value:0.0};
                }
                overallDrinksCounter[itemName].value = overallDrinksCounter[itemName].value + parseFloat(item["Subtotal"]);
                overallDrinksCounter[itemName].count = overallDrinksCounter[itemName].count + parseInt(item["Item Count"]);
                overallDrinksCounter[itemName].largeCount += parseInt(item["Large Count"]);
                overallDrinksCounter[itemName].regularCount += parseInt(item["Regular Count"]);
                if(overallDrinksCounter[itemName].toppings){
                    for(let topping in item["Toppings"]){
                        if(overallDrinksCounter[itemName].toppings[topping]){
                            overallDrinksCounter[itemName].toppings[topping] += item["Toppings"][topping];
                        } else {
                            overallDrinksCounter[itemName].toppings[topping] = item["Toppings"][topping];
                        }
                    }
                } else {
                    overallDrinksCounter[itemName].toppings = {};
                    for(let topping in item["Toppings"]){
                        if(overallDrinksCounter[itemName].toppings[topping]){
                            overallDrinksCounter[itemName].toppings[topping] += item["Toppings"][topping];
                        } else {
                            overallDrinksCounter[itemName].toppings[topping] = item["Toppings"][topping];
                        }
                    }
                }
                if(overallDrinksCounter[itemName].milkChoice){
                    for(let milk in item["Base"]){
                        if(overallDrinksCounter[itemName].milkChoice[milk]){
                            overallDrinksCounter[itemName].milkChoice[milk] += item["Base"][milk];
                        } else {
                            overallDrinksCounter[itemName].milkChoice[milk] = item["Base"][milk];
                        }
                    }
                } else {
                    overallDrinksCounter[itemName].milkChoice = {};
                    for(let milk in item["Base"]){
                        if(overallDrinksCounter[itemName].milkChoice[milk]){
                            overallDrinksCounter[itemName].milkChoice[milk] += item["Base"][milk];
                        } else {
                            overallDrinksCounter[itemName].milkChoice[milk] = item["Base"][milk];
                        }
                    }
                }
                if(isDineIn){
                    posDineInDrinksCounter[itemName] = (posDineInDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    overallDrinksCounter[itemName].dineIn = overallDrinksCounter[itemName].dineIn + parseInt(item["Item Count"]);
                } else if(isDelivery){
                    if(source === "zomato"){
                        zomatoDeliveryDrinksCounter[itemName] = (zomatoDeliveryDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    } else if(source === "swiggy"){
                        swiggyDeliveryDrinksCounter[itemName] = (swiggyDeliveryDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }
                    else if(source === "dotpe"){
                        dotpeDeliveryDrinksCounter[itemName] = (dotpeDeliveryDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }
                    overallDrinksCounter[itemName].delivery = overallDrinksCounter[itemName].delivery + parseInt(item["Item Count"]);
                } else {
                    if(source === "pos"  || source === "takeaway"){
                        posPickupDrinksCounter[itemName] = (posPickupDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }else if(source === "dotpe"){
                        posPickupDrinksCounter[itemName] = (posPickupDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }
                    overallDrinksCounter[itemName].takeaway = overallDrinksCounter[itemName].takeaway + parseInt(item["Item Count"]);
                }

            }
            else if(item["Category"] !== "Snacks" && item["Category"] !== "Bubble Tea"){
                if(Utilities.isNullOrEmpty(overallOtherCounter[itemName])){
                    overallOtherCounter[itemName] = { count : 0, dineIn : 0, takeaway : 0, delivery : 0, value:0.0, largeCount:0, regularCount:0};
                }
                overallOtherCounter[itemName].largeCount = overallOtherCounter[itemName].largeCount + (item["Large Count"] ? parseInt(item["Large Count"]) : 0);
                overallOtherCounter[itemName].regularCount = overallOtherCounter[itemName].regularCount + (item["Regular Count"] ? parseInt(item["Regular Count"]) : 0);
                overallOtherCounter[itemName].count = overallOtherCounter[itemName].count + parseInt(item["Item Count"]);
                overallOtherCounter[itemName].value = overallOtherCounter[itemName].value + parseFloat(item["Subtotal"]);
            }
            else {
                drinksCount += parseInt(item["Item Count"]);
                totalDrinksValue += parseFloat(item["Subtotal"]);
                if(Utilities.isNullOrEmpty(overallDrinksCounter[itemName])){
                    overallDrinksCounter[itemName] = { count : 0, dineIn : 0, takeaway : 0, delivery : 0, largeCount:0, regularCount:0, value:0.0};
                }
                overallDrinksCounter[itemName].value = overallDrinksCounter[itemName].value + parseFloat(item["Subtotal"]);
                overallDrinksCounter[itemName].count = overallDrinksCounter[itemName].count + parseInt(item["Item Count"]);
                overallDrinksCounter[itemName].largeCount += parseInt(item["Large Count"]);
                overallDrinksCounter[itemName].regularCount += parseInt(item["Regular Count"]);
                if(overallDrinksCounter[itemName].toppings){
                    for(let topping in item["Toppings"]){
                        if(overallDrinksCounter[itemName].toppings[topping]){
                            overallDrinksCounter[itemName].toppings[topping] += item["Toppings"][topping];
                        } else {
                            overallDrinksCounter[itemName].toppings[topping] = item["Toppings"][topping];
                        }
                    }
                } else {
                    overallDrinksCounter[itemName].toppings = {};
                    for(let topping in item["Toppings"]){
                        if(overallDrinksCounter[itemName].toppings[topping]){
                            overallDrinksCounter[itemName].toppings[topping] += item["Toppings"][topping];
                        } else {
                            overallDrinksCounter[itemName].toppings[topping] = item["Toppings"][topping];
                        }
                    }
                }

                if(isDineIn){
                    posDineInDrinksCounter[itemName] = (posDineInDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    overallDrinksCounter[itemName].dineIn = overallDrinksCounter[itemName].dineIn + parseInt(item["Item Count"]);
                } else if(isDelivery){
                    if(source === "zomato"){
                        zomatoDeliveryDrinksCounter[itemName] = (zomatoDeliveryDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    } else if(source === "swiggy"){
                        swiggyDeliveryDrinksCounter[itemName] = (swiggyDeliveryDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }
                    else if(source === "dotpe"){
                        dotpeDeliveryDrinksCounter[itemName] = (dotpeDeliveryDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }
                    overallDrinksCounter[itemName].delivery = overallDrinksCounter[itemName].delivery + parseInt(item["Item Count"]);
                } else {
                    if(source === "pos"  || source === "takeaway" || isTakeaway){
                        posPickupDrinksCounter[itemName] = (posPickupDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }else if(source === "dotpe"){
                        posPickupDrinksCounter[itemName] = (posPickupDrinksCounter[itemName] || 0) + parseInt(item["Item Count"]);
                    }
                    overallDrinksCounter[itemName].takeaway = overallDrinksCounter[itemName].takeaway + parseInt(item["Item Count"]);
                }
            }
        }
        let customerName = '';
        if(arr.length > 0){ customerName = arr[0].userName;}
        this.setState({ 
            data : arr, 
            customerName, 
            overallDrinksCounter,
            overallSnacksCounter,
            overallOtherCounter,
            overallComboCounter,
            posPickupDrinksCounter,
            posPickupSnacksCounter,
            posDineInDrinksCounter,
            posDineInSnacksCounter,
            posDineInComboCounter,
            zomatoDeliveryDrinksCounter,
            zomatoDeliverySnacksCounter,
            zomatoDeliveryComboCounter,
            swiggyDeliveryDrinksCounter,
            swiggyDeliverySnacksCounter,
            swiggyDeliveryComboCounter,            
            dotpeDeliveryDrinksCounter,
            dotpeDeliverySnacksCounter,
            dotpeDeliveryComboCounter,
            orderCount : arr.length, 
            snackCount, 
            drinksCount, 
            totalDrinksValue,
            totalFoodValue,
            money});
    }
    
    getOrders = (newStatus)=>{
        this.loadOrders();
    }

    handleBranchesChange = (event) => {
        const newSelectedBranches = event.target.value;
        this.setState({
          selectedBranches: newSelectedBranches,
        }, () => {
          // Update selected cities based on selected branches
          this.updateSelectedCitiesFromBranches(newSelectedBranches);
          // Use debounced API call to prevent hitting API on every selection
          this.debouncedLoadOrders();
        });
      };

    handleCitiesChange = (event) => {
        const selectedCities = event.target.value;
        const { branches, branchCityMap } = this.state;
        
        // Select all branches that belong to the selected cities
        const branchesInSelectedCities = branches
            .filter(branch => selectedCities.includes(branchCityMap[branch.value] || branch.city))
            .map(branch => branch.value);
        
        this.setState({
            selectedCities: selectedCities,
            selectedBranches: branchesInSelectedCities
        }, () => {
            // Use debounced API call to prevent hitting API on every selection
            this.debouncedLoadOrders();
        });
    };

    updateSelectedCitiesFromBranches = (selectedBranches) => {
        const { branches, branchCityMap, cities } = this.state;
        
        // Check if all branches of a city are selected
        const fullySelectedCities = [];
        cities.forEach(city => {
            const branchesInCity = branches.filter(b => 
                (branchCityMap[b.value] || b.city) === city
            );
            const selectedBranchesInCity = branchesInCity.filter(b => 
                selectedBranches.includes(b.value)
            );
            
            // Mark a city as selected if ALL its branches are selected
            if (branchesInCity.length > 0 && selectedBranchesInCity.length === branchesInCity.length) {
                fullySelectedCities.push(city);
            }
        });
        
        this.setState({
            selectedCities: fullySelectedCities
        });
    };

    // Debounced method for loading orders when branches change
    debouncedLoadOrders = () => {
        const { debounceTimer } = this.state;
        
        // Clear existing timer
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        
        // Set new timer for 500ms delay
        const newTimer = setTimeout(() => {
            this.loadOrders();
        }, 500);
        
        this.setState({ debounceTimer: newTimer });
    };

    // Immediate load orders for actions that should not be debounced
    immediateLoadOrders = () => {
        // Clear any pending debounced call
        if (this.state.debounceTimer) {
            clearTimeout(this.state.debounceTimer);
            this.setState({ debounceTimer: null });
        }
        // Load orders immediately
        this.loadOrders();
    };

    handleBranchSearch = (event) => {
        event.stopPropagation();
        this.setState({
            branchSearch: event.target.value
        });
    };

    getFilteredBranches = () => {
        const { branchSearch, branches } = this.state;
        if (!branchSearch.trim()) {
            return branches;
        }
        return branches.filter(branch => 
            branch.name.toLowerCase().includes(branchSearch.toLowerCase()) ||
            branch.value.toLowerCase().includes(branchSearch.toLowerCase())
        );
    };

    handleBranchSort = (sortBy) => {
        const { branchSortBy, branchSortOrder } = this.state;
        let newSortOrder = 'desc';
        if (branchSortBy === sortBy) {
            newSortOrder = branchSortOrder === 'desc' ? 'asc' : 'desc';
        }
        this.setState({ branchSortBy: sortBy, branchSortOrder: newSortOrder });
    };

    getSortedBranchTotals = () => {
        const { branchTotals, branchSortBy, branchSortOrder } = this.state;
        if (!branchTotals || branchTotals.length === 0) return [];
        
        const sorted = [...branchTotals].sort((a, b) => {
            let valA, valB;
            if (branchSortBy === 'branch') {
                valA = a.branch.toLowerCase();
                valB = b.branch.toLowerCase();
                return branchSortOrder === 'asc' 
                    ? valA.localeCompare(valB) 
                    : valB.localeCompare(valA);
            } else if (branchSortBy === 'value') {
                valA = parseFloat(a.value) || 0;
                valB = parseFloat(b.value) || 0;
            } else if (branchSortBy === 'dailyAverage') {
                valA = parseFloat(a.dailyAverage) || 0;
                valB = parseFloat(b.dailyAverage) || 0;
            } else if (branchSortBy === 'estimatedRevenue') {
                valA = parseFloat(a.estimatedRevenue) || 0;
                valB = parseFloat(b.estimatedRevenue) || 0;
            }
            return branchSortOrder === 'asc' ? valA - valB : valB - valA;
        });
        return sorted;
    };

    handleGroupByCityToggle = () => {
        this.setState(prevState => ({
            groupByCity: !prevState.groupByCity
        }));
    };

    getCityTotals = () => {
        const { branchTotals, branchCityMap, branchSortBy, branchSortOrder, viewMode, isPastMonthEnd } = this.state;
        if (!branchTotals || branchTotals.length === 0) return [];
        
        // Aggregate branch data by city
        const cityTotalsMap = {};
        
        branchTotals.forEach(item => {
            const city = branchCityMap[item.branch] || 'Unknown';
            
            if (!cityTotalsMap[city]) {
                cityTotalsMap[city] = {
                    city: city,
                    value: 0,
                    dailyAverage: 0,
                    estimatedRevenue: 0,
                    branchCount: 0,
                    branches: []
                };
            }
            
            cityTotalsMap[city].value += parseFloat(item.value) || 0;
            cityTotalsMap[city].dailyAverage += parseFloat(item.dailyAverage) || 0;
            cityTotalsMap[city].estimatedRevenue += parseFloat(item.estimatedRevenue) || 0;
            cityTotalsMap[city].branchCount += 1;
            cityTotalsMap[city].branches.push(item.branch);
        });
        
        // Convert to array and calculate average revenue per store
        let cityTotals = Object.values(cityTotalsMap);
        
        // Calculate average monthly revenue per store
        cityTotals.forEach(city => {
            if (city.branchCount > 0) {
                if (viewMode === "month" && !isPastMonthEnd) {
                    // Current month: use estimated revenue
                    city.avgRevenuePerStore = city.estimatedRevenue / city.branchCount;
                } else {
                    // Past month or day view: use net revenue
                    city.avgRevenuePerStore = city.value / city.branchCount;
                }
            } else {
                city.avgRevenuePerStore = 0;
            }
        });
        
        cityTotals.sort((a, b) => {
            let valA, valB;
            if (branchSortBy === 'branch') {
                // Sort by city name when sorting by branch
                valA = a.city.toLowerCase();
                valB = b.city.toLowerCase();
                return branchSortOrder === 'asc' 
                    ? valA.localeCompare(valB) 
                    : valB.localeCompare(valA);
            } else if (branchSortBy === 'value') {
                valA = a.value;
                valB = b.value;
            } else if (branchSortBy === 'dailyAverage') {
                valA = a.dailyAverage;
                valB = b.dailyAverage;
            } else if (branchSortBy === 'estimatedRevenue') {
                valA = a.estimatedRevenue;
                valB = b.estimatedRevenue;
            } else if (branchSortBy === 'avgRevenuePerStore') {
                valA = a.avgRevenuePerStore;
                valB = b.avgRevenuePerStore;
            }
            return branchSortOrder === 'asc' ? valA - valB : valB - valA;
        });
        
        return cityTotals;
    };

    exportBranchTotalsCsv = () => {
        const { groupByCity, viewMode, isPastMonthEnd, startDate, endDate, currentMonth } = this.state;
        const rows = groupByCity ? this.getCityTotals() : this.getSortedBranchTotals();
        const nameColumn = groupByCity ? 'City' : 'Branch';
        const revenueColumn = viewMode === 'month' && !isPastMonthEnd ? 'Net Revenue So Far' : 'Net Revenue';
        const headers = ['Rank', nameColumn, revenueColumn];

        if (groupByCity) headers.push('Branch Count');
        if (viewMode === 'month') headers.push('Daily Average');
        if (viewMode === 'month' && !isPastMonthEnd) headers.push('Estimated Revenue');
        if (groupByCity) headers.push(viewMode === 'month' ? 'Average Monthly Revenue per Store' : 'Average Store Revenue');

        const formatValue = (value) => (Number(value) || 0).toFixed(2);
        const csvRows = rows.map((item, index) => {
            const row = [index + 1, groupByCity ? item.city : item.branch, formatValue(item.value)];

            if (groupByCity) row.push(item.branchCount);
            if (viewMode === 'month') row.push(formatValue(item.dailyAverage));
            if (viewMode === 'month' && !isPastMonthEnd) row.push(formatValue(item.estimatedRevenue));
            if (groupByCity) row.push(formatValue(item.avgRevenuePerStore));

            return row;
        });
        const escapeCsvValue = (value) => `"${String(value).replace(/"/g, '""')}"`;
        const csvContent = [headers, ...csvRows]
            .map((row) => row.map(escapeCsvValue).join(','))
            .join('\r\n');
        const dateRange = viewMode === 'month' ? currentMonth : `${startDate}_to_${endDate}`;
        const fileName = `sales-by-${groupByCity ? 'city' : 'branch'}-${dateRange}.csv`;
        const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    handleDropdownClose = () => {
        // Clear search when dropdown closes
        this.setState({ branchSearch: '' });
    };

    // Custom city selector component
    renderCitySelector = () => {
        const { selectedCities, cities, loading } = this.state;
        
        return (
            <div className="cities-multiselect">
                <FormControl sx={{ minWidth: '320px', my: '1em' }}>
                    <InputLabel>Select City</InputLabel>
                    <Select
                        multiple
                        value={selectedCities}
                        onChange={this.handleCitiesChange}
                        input={<OutlinedInput label="Select City" />}
                        renderValue={(selected) => {
                            if (selected.length === 0) {
                                return <em>No cities selected</em>;
                            }
                            if (selected.length === cities.length) {
                                return <em>All cities selected</em>;
                            }
                            return (
                                <Box className="selected-branches-list" sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((city) => (
                                        <Chip
                                            key={city}
                                            label={city}
                                            size="small"
                                            sx={{
                                                backgroundColor: '#47908A',
                                                color: 'white',
                                                fontWeight: '500'
                                            }}
                                        />
                                    ))}
                                </Box>
                            );
                        }}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: 400,
                                },
                            },
                        }}
                        disabled={loading}
                    >
                        {/* Select All / Clear All options */}
                        <div className="cities-menu-header">
                            <Chip
                                label="Select All"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const { cities, branches, branchCityMap } = this.state;
                                    const allBranches = branches.map(b => b.value);
                                    this.setState({ 
                                        selectedCities: cities,
                                        selectedBranches: allBranches
                                    }, () => {
                                        this.immediateLoadOrders();
                                    });
                                }}
                                sx={{
                                    backgroundColor: '#47908A',
                                    margin: '0.5em',
                                    color: 'white',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: '#3a7a75'
                                    }
                                }}
                            />
                            <Chip
                                label="Clear All"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({ 
                                        selectedCities: [],
                                        selectedBranches: []
                                    }, () => {
                                        this.immediateLoadOrders();
                                    });
                                }}
                                sx={{
                                    backgroundColor: '#f44336',
                                    color: 'white',
                                    margin: '0.5em',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: '#d32f2f'
                                    }
                                }}
                            />
                        </div>
                        
                        {cities.map((city) => (
                            <MenuItem key={city} value={city} className="cities-menu-item">
                                <Checkbox 
                                    checked={selectedCities.indexOf(city) > -1}
                                    sx={{
                                        color: '#47908A',
                                        '&.Mui-checked': {
                                            color: '#47908A',
                                        },
                                    }}
                                />
                                <ListItemText 
                                    primary={city}
                                    primaryTypographyProps={{
                                        style: { fontSize: '14px' }
                                    }}
                                />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        );
    };

    // Custom multi-select component for branches
    renderBranchesMultiSelect = () => {
        const { selectedBranches, loading, branchSearch } = this.state;
        const filteredBranches = this.getFilteredBranches();
        
        return (
            <div className="branches-multiselect">
                <FormControl sx={{ minWidth: '320px', my: '1em' }}>
                    <InputLabel>Branches</InputLabel>
                    <Select
                        multiple
                        value={selectedBranches}
                        onChange={this.handleBranchesChange}
                        onClose={this.handleDropdownClose}
                        input={<OutlinedInput label="Branches" />}
                        renderValue={(selected) => {
                            const { branches } = this.state;
                            return (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => {
                                        const branch = branches.find(b => b.value === value);
                                        return (
                                            <Chip
                                                key={value}
                                                label={branch ? branch.name : value}
                                                size="small"
                                                sx={{
                                                    backgroundColor: '#47908A',
                                                    color: 'white',
                                                    fontWeight: '500'
                                                }}
                                            />
                                        );
                                    })}
                                </Box>
                            );
                        }}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: 400,
                                    width: 320,
                                },
                            },
                        }}
                        disabled={loading}
                    >
                        {/* Search input */}
                        <div className="branches-search-container" onClick={(e) => e.stopPropagation()}>
                            <TextField
                                size="small"
                                placeholder="Search branches..."
                                value={branchSearch}
                                onChange={this.handleBranchSearch}
                                fullWidth
                                autoComplete="off"
                                onClick={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                                onKeyDown={(e) => e.stopPropagation()}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <FontAwesomeIcon icon={faSearch} size="sm" style={{ color: '#666' }} />
                                        </InputAdornment>
                                    ),
                                    endAdornment: branchSearch && (
                                        <InputAdornment position="end">
                                            <FontAwesomeIcon 
                                                icon={faTimes} 
                                                size="sm" 
                                                style={{ 
                                                    color: '#666', 
                                                    cursor: 'pointer',
                                                    padding: '4px'
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.setState({ branchSearch: '' });
                                                }}
                                                onMouseDown={(e) => e.preventDefault()}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#e0e0e0',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#47908A',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#47908A',
                                        },
                                    },
                                }}
                            />
                        </div>

                        {/* Select All / Clear All options */}
                        <div className="branches-menu-header">
                            <Chip
                                label="Select All"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const { branches, cities } = this.state;
                                    const allBranches = branches.map(b => b.value);
                                    this.setState({ 
                                        selectedBranches: allBranches,
                                        selectedCities: cities
                                    }, () => {
                                        this.immediateLoadOrders();
                                    });
                                }}
                                sx={{
                                    backgroundColor: '#47908A',
                                    margin: '0.5em',
                                    color: 'white',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: '#3a7a75'
                                    }
                                }}
                            />
                            <Chip
                                label="Clear All"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({ 
                                        selectedBranches: [],
                                        selectedCities: []
                                    }, () => {
                                        this.immediateLoadOrders();
                                    });
                                }}
                                sx={{
                                    backgroundColor: '#f44336',
                                    color: 'white',
                                    margin: '0.5em',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: '#d32f2f'
                                    }
                                }}
                            />
                        </div>
                        
                        {filteredBranches.map((branch) => (
                            <MenuItem key={branch.value} value={branch.value} className="branches-menu-item">
                                <Checkbox 
                                    checked={selectedBranches.indexOf(branch.value) > -1}
                                    sx={{
                                        color: '#47908A',
                                        '&.Mui-checked': {
                                            color: '#47908A',
                                        },
                                    }}
                                />
                                <ListItemText 
                                    primary={branch.name}
                                    primaryTypographyProps={{
                                        style: { fontSize: '14px' }
                                    }}
                                />
                            </MenuItem>
                        ))}
                        
                        {filteredBranches.length === 0 && (
                            <div className="branches-no-results">
                                <p>No branches found matching "{branchSearch}"</p>
                            </div>
                        )}
                    </Select>
                </FormControl>
            </div>
        );
    };

    loadBranches = async () => {
        try {
            const db = firebase.firestore();
            const branchesSnapshot = await db.collection('branches').get();
            const branches = [];
            const branchCityMap = {};
            
            branchesSnapshot.forEach((doc) => {
                const data = doc.data();
                if (data.branchName) {
                    let displayName;
                    let branchValue;
                    const city = data.city || 'Unknown';
                    
                    // Special mappings for specific branches
                    if (data.branchName === 'Got Tea - Deer Park') {
                        displayName = 'Safdarjung (GOT-001)';
                        branchValue = 'Safdarjung';
                    } else if (data.branchName === 'Got Tea - GK2') {
                        displayName = 'GK2 (GOT-003)';
                        branchValue = 'GreaterKailash2';
                    } else if (data.branchName === 'Got Tea - Galleria') {
                        displayName = 'Galleria (GOT-004)';
                        branchValue = 'Galleria';
                    } else {
                        // Remove "Got Tea - " prefix from branchName to get display name
                        displayName = data.branchName.replace(/^Got Tea - /i, '').trim() + ` (${data.branchCode || 'GOT-000'})`;
                        branchValue = data.branchName;
                    }
                    
                    // Store branch-to-city mapping
                    branchCityMap[branchValue] = city;
                    
                    branches.push({
                        name: displayName,
                        value: branchValue,
                        city: city
                    });
                }
            });
            
            // Sort branches by name for consistent ordering
            branches.sort((a, b) => a.name.localeCompare(b.name));
            
            // Extract unique cities
            const citiesSet = new Set();
            branches.forEach(branch => {
                if (branch.city) {
                    citiesSet.add(branch.city);
                }
            });
            const cities = Array.from(citiesSet).sort();
            
            // Set all branches as selected by default
            const selectedBranches = branches.map(b => b.value);
            const selectedCities = cities; // Select all cities by default
            
            this.setState({ 
                branches,
                selectedBranches,
                branchCityMap,
                cities,
                selectedCities
            }, () => {
                // Load orders after branches are loaded
                this.loadOrders();
            });
        } catch (error) {
            console.error('Error loading branches:', error);
            // Fallback to empty array if there's an error
            this.setState({ 
                branches: [],
                selectedBranches: [],
                branchCityMap: {},
                cities: [],
                selectedCities: []
            });
        }
    };

    componentDidMount(){
        firebase.auth().onAuthStateChanged(user => {
            let loggedIn = !!user;
            if(loggedIn){
                this.loadBranches();
            } else {
                window.location.href = '/login';
            }
        });
    }

    componentWillUnmount(){
        clearInterval(this.timer);
        // Clear debounce timer to prevent memory leaks
        if (this.state.debounceTimer) {
            clearTimeout(this.state.debounceTimer);
        }
    }

    setStartDate = (e) => {
        this.setState({startDate : e.target.value},()=>{
            this.filterOrders();
            // this.loadOrders();
        });
    }

    setMonth = async (e) => {
        const startDate = moment(e.target.value).startOf('month').format('YYYY-MM-DD');
        const endDate   = moment(e.target.value).endOf('month').format('YYYY-MM-DD');
        this.setState({
            currentMonth : e.target.value,
            startDate, 
            endDate
        },()=>{
            this.filterOrders();
            // this.loadOrders();
        });
    }

    onUpdateClick = ()=>{
        this.loadOrders();
    }

    setEndDate = (e) => {
        this.setState({endDate : e.target.value},()=>{
            this.filterOrders();
            // this.loadOrders();
        });
    }

    handleChangeMode = (event, mode)=>{
            let updateObj = {
                viewMode : mode
            };
            this.setState(updateObj,()=>{
                this.loadOrders();
            });
    }

    handleChangeStoreMode = (event)=>{
        let goalKey = `${this.state.storeMode}-${moment(this.state.currentMonth).format('MM-YYYY')}`;
        let updateObj = {
            goalKey,
            storeMode : event.target.value
        };
        this.setState(updateObj,()=>{
            this.loadOrders();
        });
    }
    
    
    render(){
        const { 
            viewMode,
            storeMode,
            selectedBranches,
            toppingsCounter,
            overallDrinksCounter,
            overallSnacksCounter,
            overallOtherCounter,
            overallComboCounter,
            posPickupDrinksCounter,
            posPickupSnacksCounter,
            posDineInDrinksCounter,
            posDineInSnacksCounter,
            zomatoDeliveryDrinksCounter,
            zomatoDeliverySnacksCounter,
            swiggyDeliveryDrinksCounter,
            swiggyDeliverySnacksCounter,
            dotpeDeliveryDrinksCounter,
            dotpeDeliverySnacksCounter,
            drinksCount, 
            snackCount, 
            cash,
            currentMonth,
            startDate, 
            endDate,
            orderTypeTotals,
            sourceTotals,
            revenueTotals,
            periodTotals,
            totalOrderCount,
            totalAmount,
            totalNetAmount,
            totalDiscounts,
            loading,
            goalData,
            daysYet,
            totalDrinksValue,
            totalFoodValue,
            groupByCity,
            isPastMonthEnd,
            loadError
         } = this.state;
        
        let revenueGoal = 0.0;
        let progress = 0.0;
        if(goalData && goalData.revenueGoal){
            revenueGoal = goalData.revenueGoal;
            progress = (totalAmount / revenueGoal)  * 100.0;
        }
        let orderTypeBreakdown = {
            dineIn : 0.0,
            takeaway : 0.0,
            zomato : 0.0,
            swiggy : 0.0
        };

        if(orderTypeTotals){
            if(orderTypeTotals['DINEIN']){
                orderTypeBreakdown.dineIn = orderTypeTotals['DINEIN'].total;
            }
            if(orderTypeTotals['TAKEAWAY']){
                orderTypeBreakdown.takeaway = orderTypeTotals['TAKEAWAY'].total;
            }
        }
        if(sourceTotals){
            orderTypeBreakdown.zomato = 0.0;
            if(sourceTotals['Zomato']){
                orderTypeBreakdown.zomato += sourceTotals['Zomato'].total;
            }
            if(sourceTotals['Zomato Gottea']){
                orderTypeBreakdown.zomato += sourceTotals['Zomato Gottea'].total;
            }
            orderTypeBreakdown.swiggy = 0.0;
            if(sourceTotals['Swiggy']){
                orderTypeBreakdown.swiggy += sourceTotals['Swiggy'].total;
            }
            if(sourceTotals['Swiggy Gottea']){
                orderTypeBreakdown.swiggy += sourceTotals['Swiggy Gottea'].total;
            }
        }

        return <div className='reportContainer'>
            <ReportsHeader/>
            <div className='wrapper'>
                {loadError && <div role="alert" className="report-load-error">{loadError}</div>}
                <div className='infoDiv'>
                <ToggleButtonGroup
                    style={{marginTop:20, marginBottom:10}}
                    color="primary"
                    disabled={loading}
                    value={viewMode}
                    exclusive
                    onChange={this.handleChangeMode}
                    >
                    <ToggleButton disabled={loading} value="day">Day</ToggleButton>
                    <ToggleButton disabled={loading} value="month">Month</ToggleButton>
                    </ToggleButtonGroup>
                    {/* <FormControl sx={{ my: '1em'}}>
                    <InputLabel>Branch</InputLabel>
                    <Select
                    color="primary"
                    value={storeMode}
                    label="Branch"
                    onChange={this.handleChangeStoreMode}
                    >
                    {this.state.branches.map((b, branchIndex)=><MenuItem key={b.name+branchIndex} disabled={loading} value={b.value}>{b.name}</MenuItem>)}
                    </Select>
                    </FormControl>
                    */}

            {this.renderCitySelector()}
            {this.renderBranchesMultiSelect()}
            
            {/* Branch selection summary */}
            <div className="branches-summary">
                <span>
                    {selectedBranches.length === 0 
                        ? 'No branches selected' 
                        : selectedBranches.length === this.state.branches.length
                        ? 'All branches selected'
                        : `${selectedBranches.length} of ${this.state.branches.length} branches selected`
                    }
                </span>
                {this.state.debounceTimer && (
                    <span className="branches-updating-indicator">
                        Updating...
                    </span>
                )}
                {selectedBranches.length > 0 && selectedBranches.length < this.state.branches.length && (
                    <Chip
                        label="Clear Selection"
                        size="small"
                        variant="outlined"
                        onClick={() => {
                            this.setState({ 
                                selectedBranches: [],
                                selectedCities: []
                            }, () => {
                                this.immediateLoadOrders();
                            });
                        }}
                        sx={{
                            borderColor: '#47908A',
                            color: '#47908A',
                            cursor: 'pointer',
                            marginLeft: '0.5em',
                            '&:hover': {
                                backgroundColor: '#47908A',
                                color: 'white'
                            }
                        }}
                    />
                )}
            </div>
                
                { loading ? <Loader/> : <React.Fragment>
                    <div className='dateContainer'>
                    {viewMode === "day" ? <>                    
                    <input disabled={loading} type='date' className='dateInput' onChange={this.setStartDate} value={startDate}/>
                    <input disabled={loading} type='date' className='dateInput' onChange={this.setEndDate} value={endDate}/>
                    </>  : ''}
                    {viewMode === "month" ? <>
                    <input disabled={loading} type='month' className='dateInput' onChange={this.setMonth} value={currentMonth}/>
                    </> : ''}
                    <div className='updateBtn' onClick={this.onUpdateClick}> 
                    <FontAwesomeIcon className='btnIcon' icon={faArrowCircleRight} size='1x'/>
                    </div>
                    </div>
                    {viewMode === "month" ? <>
                    {goalData ? <div className="progressLineContainer">
                        <div><span>Target Revenue </span></div>
                        <div className="progressLine"><Line percent={progress.toFixed(2)} strokeWidth="2" strokeColor="#47908A" /></div>
                        <div>₹{Utilities.formatIndianCurrency(revenueGoal)}</div>
                        </div> : ''}
                    </> : ''}
                    {/* Summary Stats Grid */}
                    <div className="summaryStatsContainer">
                        <div className="statsGrid">
                            <div className="statCard statCardPrimary">
                                <span className="statLabel">Total Orders</span>
                                <span className="statValue">{Number(totalOrderCount || 0).toLocaleString('en-IN')}</span>
                            </div>
                            <div className="statCard">
                                <span className="statLabel">Avg Order Value</span>
                                <span className="statValue">₹{Utilities.formatIndianCurrency(parseFloat(totalNetAmount) / totalOrderCount)}</span>
                            </div>
                            {viewMode === "month" && (
                                <div className="statCard">
                                    <span className="statLabel">Daily Avg Revenue</span>
                                    <span className="statValue">₹{Utilities.formatIndianCurrency(this.state.averageDailyRevenue)}</span>
                                </div>
                            )}
                            <div className="statCard statCardDiscount">
                                <span className="statLabel">Discounts</span>
                                <span className="statValue">₹{Utilities.formatIndianCurrency(totalDiscounts)}</span>
                            </div>
                        </div>
                        <div className="netRevenueCard">
                            <span className="netLabel">{viewMode === "month" && !isPastMonthEnd ? "Net Revenue so Far" : "Net Revenue"}</span>
                            <span className="netValue">₹{Utilities.formatIndianCurrency(totalNetAmount)}</span>
                        </div>
                        {viewMode === "month" && !isPastMonthEnd && (
                            <div className="netRevenueCard estimatedRevenueCard">
                                <span className="netLabel">Estimated Month Revenue</span>
                                <span className="netValue">₹{Utilities.formatIndianCurrency(this.state.expectedTotal)}</span>
                            </div>
                        )}
                    </div>
                    
                    {/* Group by City Toggle */}
                    <div className="branchTableActions">
                        <ToggleButtonGroup
                            color="primary"
                            value={groupByCity ? 'city' : 'branch'}
                            exclusive
                            onChange={(e, val) => val && this.setState({ groupByCity: val === 'city' })}
                            size="small"
                        >
                            <ToggleButton value="branch">By Branch</ToggleButton>
                            <ToggleButton value="city">By City</ToggleButton>
                        </ToggleButtonGroup>
                        <button
                            type="button"
                            className="exportCsvButton"
                            onClick={this.exportBranchTotalsCsv}
                            disabled={groupByCity ? this.getCityTotals().length === 0 : this.getSortedBranchTotals().length === 0}
                        >
                            <FontAwesomeIcon icon={faFileCsv} />
                            Export CSV
                        </button>
                    </div>
                    
                    {/* Desktop Table View */}
                    <div className="branchTableContainer">
                        <table className="branchTable">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th 
                                        className={`sortableHeader ${this.state.branchSortBy === 'branch' ? 'active' : ''}`}
                                        onClick={() => this.handleBranchSort('branch')}
                                    >
                                        {groupByCity ? 'City' : 'Branch'}
                                        <span className="sortIcon">
                                            {this.state.branchSortBy === 'branch' 
                                                ? (this.state.branchSortOrder === 'asc' ? ' ↑' : ' ↓')
                                                : ' ↕'}
                                        </span>
                                    </th>
                                    <th 
                                        className={`sortableHeader ${this.state.branchSortBy === 'value' ? 'active' : ''}`}
                                        onClick={() => this.handleBranchSort('value')}
                                    >
                                        {viewMode === "month" && !isPastMonthEnd ? "Net Rev. so Far" : "Net Revenue"}
                                        <span className="sortIcon">
                                            {this.state.branchSortBy === 'value' 
                                                ? (this.state.branchSortOrder === 'asc' ? ' ↑' : ' ↓')
                                                : ' ↕'}
                                        </span>
                                    </th>
                                    {viewMode === "month" && (
                                        <th 
                                            className={`sortableHeader ${this.state.branchSortBy === 'dailyAverage' ? 'active' : ''}`}
                                            onClick={() => this.handleBranchSort('dailyAverage')}
                                        >
                                            Daily Avg
                                            <span className="sortIcon">
                                                {this.state.branchSortBy === 'dailyAverage' 
                                                    ? (this.state.branchSortOrder === 'asc' ? ' ↑' : ' ↓')
                                                    : ' ↕'}
                                            </span>
                                        </th>
                                    )}
                                    {viewMode === "month" && !isPastMonthEnd && (
                                        <th 
                                            className={`sortableHeader ${this.state.branchSortBy === 'estimatedRevenue' ? 'active' : ''}`}
                                            onClick={() => this.handleBranchSort('estimatedRevenue')}
                                        >
                                            Est. Revenue
                                            <span className="sortIcon">
                                                {this.state.branchSortBy === 'estimatedRevenue' 
                                                    ? (this.state.branchSortOrder === 'asc' ? ' ↑' : ' ↓')
                                                    : ' ↕'}
                                            </span>
                                        </th>
                                    )}
                                    {groupByCity && (
                                        <th 
                                            className={`sortableHeader ${this.state.branchSortBy === 'avgRevenuePerStore' ? 'active' : ''}`}
                                            onClick={() => this.handleBranchSort('avgRevenuePerStore')}
                                        >
                                            {viewMode === "month" ? "Avg. Monthly Revenue per Store" : "Avg. Store Revenue"}
                                            <span className="sortIcon">
                                                {this.state.branchSortBy === 'avgRevenuePerStore' 
                                                    ? (this.state.branchSortOrder === 'asc' ? ' ↑' : ' ↓')
                                                    : ' ↕'}
                                            </span>
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {groupByCity ? (
                                    this.getCityTotals().map((item, index) => (
                                        <tr key={`city-${item.city}-${index}`}>
                                            <td className="branchRank">{index + 1}</td>
                                            <td className="branchName cityName">{item.city} ({item.branchCount})</td>
                                            <td className="branchRevenue">₹{Utilities.formatIndianCurrency(item.value)}</td>
                                            {viewMode === "month" && (
                                                <td className="branchDailyAvg">₹{Utilities.formatIndianCurrency(item.dailyAverage)}</td>
                                            )}
                                            {viewMode === "month" && !isPastMonthEnd && (
                                                <td className="branchEstRevenue">₹{Utilities.formatIndianCurrency(item.estimatedRevenue)}</td>
                                            )}
                                            <td className="branchEstRevenue">₹{Utilities.formatIndianCurrency(item.avgRevenuePerStore)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    this.getSortedBranchTotals().map((item, index) => (
                                        <tr key={`${item.branch}${index}`}>
                                            <td className="branchRank">{index + 1}</td>
                                            <td className="branchName">{item.branch}</td>
                                            <td className="branchRevenue">₹{Utilities.formatIndianCurrency(parseFloat(item.value))}</td>
                                            {viewMode === "month" && (
                                                <td className="branchDailyAvg">₹{Utilities.formatIndianCurrency(item.dailyAverage)}</td>
                                            )}
                                            {viewMode === "month" && !isPastMonthEnd && (
                                                <td className="branchEstRevenue">₹{Utilities.formatIndianCurrency(item.estimatedRevenue)}</td>
                                            )}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* Mobile Card View */}
                    <div className="branchSplits">
                    {groupByCity ? (
                        this.getCityTotals().map((item, index) => (
                            <div key={`city-card-${item.city}-${index}`} className="branchCard cityCard">
                                <div className="branchCardHeader">
                                    <span className="branchRankBadge">{index + 1}</span>
                                    <p className='sourceTitle'>{item.city} ({item.branchCount})</p>
                                </div>
                                <div className="branchCardBody">
                                    <div className="branchMetric">
                                        <span className="branchMetricLabel">{viewMode === "month" && !isPastMonthEnd ? "Net Rev so Far" : "Net Rev"}</span>
                                        <span className="branchMetricValue">₹{Utilities.formatIndianCurrency(item.value)}</span>
                                    </div>
                                    {viewMode === "month" && item.dailyAverage > 0 && (
                                        <div className="branchMetric">
                                            <span className="branchMetricLabel">Daily Avg</span>
                                            <span className="branchMetricValue branchMetricValueHighlight">₹{Utilities.formatIndianCurrency(item.dailyAverage)}</span>
                                        </div>
                                    )}
                                    {viewMode === "month" && !isPastMonthEnd && item.estimatedRevenue > 0 && (
                                        <div className="branchMetric">
                                            <span className="branchMetricLabel">Est. Revenue</span>
                                            <span className="branchMetricValue branchMetricValueEstimated">₹{Utilities.formatIndianCurrency(item.estimatedRevenue)}</span>
                                        </div>
                                    )}
                                    <div className="branchMetric">
                                        <span className="branchMetricLabel">{viewMode === "month" ? "Avg. Monthly Revenue per Store" : "Avg. Store Revenue"}</span>
                                        <span className="branchMetricValue branchMetricValueEstimated">₹{Utilities.formatIndianCurrency(item.avgRevenuePerStore)}</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        this.state.branchTotals.map((item,index)=>{
                            return <div key={`${item.branch}${index}`} className="branchCard">
                            <div className="branchCardHeader">
                                <span className="branchRankBadge">{index + 1}</span>
                                <p className='sourceTitle'>{item.branch}</p>
                            </div>
                            <div className="branchCardBody">
                                <div className="branchMetric">
                                    <span className="branchMetricLabel">{viewMode === "month" && !isPastMonthEnd ? "Net Rev so Far" : "Net Rev"}</span>
                                    <span className="branchMetricValue">₹{Utilities.formatIndianCurrency(parseFloat(item.value))}</span>
                                </div>
                                {viewMode === "month" && item.dailyAverage > 0 && (
                                    <div className="branchMetric">
                                        <span className="branchMetricLabel">Daily Avg</span>
                                        <span className="branchMetricValue branchMetricValueHighlight">₹{Utilities.formatIndianCurrency(item.dailyAverage)}</span>
                                    </div>
                                )}
                                {viewMode === "month" && !isPastMonthEnd && item.estimatedRevenue > 0 && (
                                    <div className="branchMetric">
                                        <span className="branchMetricLabel">Est. Revenue</span>
                                        <span className="branchMetricValue branchMetricValueEstimated">₹{Utilities.formatIndianCurrency(item.estimatedRevenue)}</span>
                                    </div>
                                )}
                            </div>
                            </div>
                        })
                    )}
                    </div>
                    <div className="revenueSplits">
                    {revenueTotals.map((source,index)=>{
                        return <div key={`${source.Source}${index}`}>
                        <p className='sourceTitle'>{source.Source}</p>
                        <p className='orderCount'>{source.count} Orders</p>
                        <p className={`money`}>₹{Utilities.formatIndianCurrency(parseFloat(source["total"]))}</p>
                        <p className={`money`}>AOV : ₹{Utilities.formatIndianCurrency(parseFloat(source.aov))}</p>
                        </div>
                    })}
                    </div>
                    </React.Fragment>}
            </div>
            <div className="countsTableContainer">
            { loading ? <Loader/> : 
                <><table className="countsTable">
                    <tr>
                        <td className="hideBorder" rowSpan="1"></td>
                        <td colSpan="2">In-Store</td>
                        <td colSpan="2">Delivery</td>
                        <td rowSpan="4">Total</td>
                    </tr>
                    <tr>
                        <td className="hideBorder" colSpan="1"></td>
                        <td colSpan="2">{((orderTypeBreakdown.dineIn+orderTypeBreakdown.takeaway)/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                        <td colSpan="2">{((orderTypeBreakdown.zomato+orderTypeBreakdown.swiggy)/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                    </tr>
                    <tr>
                        <td className="hideBorder" colSpan="1"></td>
                        <td>Dine In</td>
                        <td>Takeaway</td>
                        <td>Zomato</td>
                        <td>Swiggy</td>
                    </tr>
                    <tr>
                        <td className="hideBorder" colSpan="1"></td>
                        <td>{(orderTypeBreakdown.dineIn/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                        <td>{(orderTypeBreakdown.takeaway/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                        <td>{(orderTypeBreakdown.zomato/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                        <td>{(orderTypeBreakdown.swiggy/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                        <td>Count %</td>
                        <td>Revenue</td>
                        <td>Revenue %</td>
                    </tr>
                    <tr>
                        <td>Drinks</td>
                        <td><Totals title={'In-Store Dine In Drinks'} data={posDineInDrinksCounter}/></td>
                        <td><Totals title={'In-Store Takeaway Drinks'} data={posPickupDrinksCounter}/></td>
                        <td><Totals title={'Zomato Delivery Drinks'} data={zomatoDeliveryDrinksCounter}/></td>
                        <td><Totals title={'Swiggy Delivery Drinks'} data={swiggyDeliveryDrinksCounter}/></td>
                        <td>{drinksCount}</td>
                        <td>{(drinksCount/(snackCount+drinksCount) * 100.0).toFixed(2)}%</td>
                        <td>₹{Utilities.formatIndianCurrency(totalDrinksValue)}</td>
                        <td>{(totalDrinksValue/(totalDrinksValue+totalFoodValue) * 100.0).toFixed(2)}%</td>
                    </tr>
                    <tr>
                        <td>Food</td>
                        <td><Totals title={'In-Store Dine In Food'} data={posDineInSnacksCounter}/></td>
                        <td><Totals title={'In-Store Takeaway Food'} data={posPickupSnacksCounter}/></td>
                        <td><Totals title={'Zomato Delivery Food'} data={zomatoDeliverySnacksCounter}/></td>
                        <td><Totals title={'Swiggy Delivery Food'} data={swiggyDeliverySnacksCounter}/></td>
                        <td>{snackCount}</td>
                        <td>{(snackCount/(snackCount+drinksCount) * 100.0).toFixed(2)}%</td>
                        <td>₹{Utilities.formatIndianCurrency(totalFoodValue)}</td>
                        <td>{(totalFoodValue/(totalDrinksValue+totalFoodValue) * 100.0).toFixed(2)}%</td>
                    </tr>
                </table>
                <table className="countsTable">
                    <tr>
                        <td>Time</td>
                        <td>Breakfast</td>
                        <td>Lunch</td>
                        <td>Snacks</td>
                        <td>Dinner</td>
                        <td>Late Night</td>
                        <td>Other</td>
                    </tr>
                    <tr>
                        <td rowSpan="1">%age</td>
                        <td>{((periodTotals['Breakfast'] ? periodTotals['Breakfast'].total : 0.0)/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                        <td>{((periodTotals['Lunch'] ? periodTotals['Lunch'].total : 0.0)/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                        <td>{((periodTotals['Snacks'] ? periodTotals['Snacks'].total : 0.0)/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                        <td>{((periodTotals['Dinner'] ? periodTotals['Dinner'].total : 0.0)/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                        <td>{((periodTotals['Late Night'] ? periodTotals['Late Night'].total : 0.0)/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                        <td>{((periodTotals['Other'] ? periodTotals['Other'].total : 0.0)/(totalNetAmount) * 100.0).toFixed(2)}%</td>
                    </tr>
                    <tr>
                        <td rowSpan="1"># Orders</td>
                        <td><h3>{(periodTotals['Breakfast'] ? periodTotals['Breakfast'].count : 0)}</h3></td>
                        <td><h3>{(periodTotals['Lunch'] ? periodTotals['Lunch'].count : 0)}</h3></td>
                        <td><h3>{(periodTotals['Snacks'] ? periodTotals['Snacks'].count : 0)}</h3></td>
                        <td><h3>{(periodTotals['Dinner'] ? periodTotals['Dinner'].count : 0)}</h3></td>
                        <td><h3>{(periodTotals['Late Night'] ? periodTotals['Late Night'].count : 0)}</h3></td>
                        <td><h3>{(periodTotals['Other'] ? periodTotals['Other'].count : 0)}</h3></td>
                    </tr>
                </table>
                </> }
                
            </div>
                <StatsTable loading={loading} title={'Toppings Sold'} data={toppingsCounter} skipFlavourBreakdown/>   
                <StatsTable loading={loading} title={'Online Combos'} data={overallComboCounter}/>   
                <StatsTable loading={loading} title={'Drinks Sold (Including Combo)'} showLargeAndSmall={true} data={overallDrinksCounter}/>
                <StatsTable loading={loading} title={'Food Sold (Including Combo)'} data={overallSnacksCounter}/>  
                <StatsTable loading={loading} skipFlavourBreakdown title={'Other Items Sold'} showLargeAndSmall={true} data={overallOtherCounter}/>       
            </div>
            </div>
    } 
}

export default Reports;
